import React from 'react';
import {formattaOra, siglaFuso} from '../../../utils/formato';
import {ascolta} from '../../../preferenze';
import i18next from 'i18next';

/**
 * L'OROLOGIO IN TESTATA (modulo Testata › orologio).
 *
 * COSA FA. Scrive l'ora nel fuso in cui il sito mostra gli orari delle
 * partite — quello scelto dal giocatore nelle Impostazioni, altrimenti
 * quello della skin — con la sigla del fuso (CEST, BRT), cosi' orologio e
 * orari delle partite dicono la stessa cosa. Si aggiorna da solo e si
 * riscrive quando il giocatore cambia fuso.
 *
 * COSA NON FA. Non decide il fuso: lo leggono `formattaOra` e `siglaFuso`
 * dalle preferenze, come tutto il sito. Sul telefono non si disegna: l'ora
 * la dice il telefono (BarraAlta lo nasconde sotto i 1024 px).
 */
export default function Orologio() {
  const [, ridisegna] = React.useState(0);
  React.useEffect(() => {
    const smetti = ascolta(() => ridisegna((n) => n + 1));
    /* Al minuto tondo, poi ogni minuto: non c'e' niente da leggere fra un
       minuto e l'altro, e un intervallo al secondo sarebbe spreco. */
    let intervallo = null;
    const primo = window.setTimeout(() => {
      ridisegna((n) => n + 1);
      intervallo = window.setInterval(() => ridisegna((n) => n + 1), 60000);
    }, 60000 - (Date.now() % 60000));
    return () => {
      smetti();
      window.clearTimeout(primo);
      if (intervallo) window.clearInterval(intervallo);
    };
  }, []);
  const adesso = new Date();
  return (
    <span className="testata-orologio" title={i18next.t('Ora nel fuso in cui il sito mostra gli orari delle partite (') + siglaFuso(adesso) + ')'}>
      <time dateTime={adesso.toISOString()}>{formattaOra(adesso, 'ora')}</time>
      <small>{siglaFuso(adesso)}</small>
    </span>
  );
}
